<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex justify-content-between align-items-start p-2">
        <!-- Close button on the right (RTL) or left (LTR) -->
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeSuNewOrderSupplierDialog()"
            class="close-icon d-flex align-items-center justify-content-center" 
            [class.text-white]="isDarkMode"
            style="order: 2;">
            <mat-icon>close</mat-icon>
        </button>
        
        <!-- Default settings mode button - only shown before first confirmation -->
        <button *ngIf="!showOrderSummary" 
                type="button" 
                mat-raised-button 
                (click)="toggleDefaultSettingsMode()"
                class="rounded-pill text-green"
                [class.text-white]="isDarkMode"
                style="order: 1; font-size: 0.75rem;">
            {{ getDefaultSettingsModeText() | translate }}
        </button>
    </div>

    <div
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 w-100 zx-min-h-modal">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            {{ "su-management.new-order-from-supplier" | translate }}
        </h4>
        
        <!-- Branch and printer info - Always visible -->
        <div *ngIf="!isLoading && branch" class="d-flex align-items-center gap-2 w-100 justify-content-center mt-3">
            <img [src]="getPrintingServiceIcon()" alt="printing service icon" class="d-block d-md-none zx-small-icon-size" 
                 >
            <img [src]="getPrintingServiceIcon()" alt="printing service icon" class="d-none d-md-block zx-medium-icon-size" 
                 >
            <img *ngIf="!isPicsPrinter" [src]="getBranchIcon()" alt="branch icon" class="d-block d-md-none zx-small-icon-size"
                 >
            <img *ngIf="!isPicsPrinter" [src]="getBranchIcon()" alt="branch icon" class="d-none d-md-block zx-medium-icon-size"
                 >
            <div class="d-flex align-items-center">
                <span class="d-block d-md-none h6 text-green mb-0" [class.text-white]="isDarkMode">
                    {{ getDisplayText() | translate }}
                </span>
                <span class="d-none d-md-block h4 text-green mb-0" [class.text-white]="isDarkMode">
                    {{ getDisplayText() | translate }}
                </span>
            </div>
        </div>
        
        <!-- loading -->
        <div *ngIf="isLoading" class="d-flex w-100 flex-grow-1 justify-content-center align-items-center">
            <mat-spinner class="zx-medium-icon-size" color="primary"></mat-spinner>
        </div>
        
        <!-- Main Content Area - Shows spinner or success message when submitting -->
        <div *ngIf="!isLoading" class="d-flex flex-column flex-grow-1 w-100 pb-2">
            
            <!-- Spinner when submitting order -->
            <div *ngIf="isSubmittingOrder && !showSuccessMessage" class="d-flex flex-column align-items-center justify-content-center" style="flex-grow: 1; min-height: 400px;">
                <mat-spinner class="mb-3" color="primary" style="width: 80px; height: 80px;"></mat-spinner>
                <h5 class="text-muted">{{ 'su-management.submitting-order' | translate }}</h5>
            </div>
            
            <!-- Success message -->
            <div *ngIf="showSuccessMessage" class="d-flex flex-column align-items-center justify-content-center" style="flex-grow: 1; min-height: 400px;">
                <mat-icon class="mb-3" style="font-size: 80px; width: 80px; height: 80px; color: var(--zx-green);">check_circle</mat-icon>
                <h4 class="mb-0 fw-bold" style="color: var(--zx-green);">{{ "su-management.order-created-success" | translate }}</h4>
            </div>
            
            <!-- Dialog content container - hidden when submitting -->
            <div *ngIf="!isSubmittingOrder && !showSuccessMessage">
            <!-- Loading spinner -->
<div *ngIf="!isInitialDataLoaded" class="d-flex justify-content-center align-items-center" style="height: 400px;">
    <div class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<!-- Main content -->
<div *ngIf="isInitialDataLoaded && !showOrderSummary">
            <!-- Paper Section (normal) or Ribon Images Section (pics printer) -->
            <div class="mb-4" *ngIf="!isPicsPrinter || printingService !== 'express'">
                <h5 class="text-green fw-bold mb-4 px-3">
                    {{ "printing-table.paper" | translate }}
                </h5>
                <div *ngIf="getPaperTypes().length > 0" class="row g-2">
                    <div *ngFor="let paper of getPaperTypes()" class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                        <div class="row w-100">
                            <div class="d-flex justify-content-between align-items-center p-2 h-100">
                            <div class="d-flex flex-column px-3">
                                <span class="fw-bold mb-2" [class.text-white]="isDarkMode">
                                    <span *ngIf="printingService !== 'express'">{{ paper.paperType.paperName }}</span>
                                    <span *ngIf="printingService === 'express'">{{ paper.paperName }}</span>
                                </span>
                                <span class="text-muted small mb-2" *ngIf="printingService !== 'express'">
                                    {{ "printing-table.width" | translate }}: {{ (paper.paperType.paperWidth / 1000) | number:'1.0-0' }} <span class="text-muted small">{{ "printing-table.dimensions-cm" | translate }}</span>
                                </span>
                                <span class="text-muted small mb-2" *ngIf="printingService === 'express' && getExpressPaperDimensions(paper)">
                                    {{ "printing-table.dimensions" | translate }}: 
                                    <span class="d-inline-flex align-items-center gap-1">
                                        <span>{{ getExpressPaperDimensions(paper)?.height }}</span>
                                        <span>×</span>
                                        <span>{{ getExpressPaperDimensions(paper)?.width }}</span>
                                        <span class="text-muted small">{{ "printing-table.dimensions-cm" | translate }}</span>
                                    </span>
                                </span>
                                <span class="text-muted small mb-2" *ngIf="printingService !== 'express'">
                                    {{ "su-management.weight" | translate }}: {{ paper.paperType.paperWeight }} <span class="text-muted small">{{ "su-management.branches_paper-weight-g" | translate }}</span>
                                </span>
                                <div class="text-muted small mb-2">
                                    <div class="mb-1">{{ "su-management.price" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')" class="fw-bold text-green">
                                            <span *ngIf="printingService !== 'express'">{{ (updatedValues['paper'] && updatedValues['paper'][paper.paperType.paperType + '_price'] !== undefined) ? updatedValues['paper'][paper.paperType.paperType + '_price'] : paper.paperType.defaultPrice }}</span>
                                            <span *ngIf="printingService === 'express'">{{ (updatedValues['paper'] && updatedValues['paper'][paper.serial_name + '_price'] !== undefined) ? updatedValues['paper'][paper.serial_name + '_price'] : getExpressPaperDefaultPrice(paper) }}</span>
                                        </span>
                                        <input *ngIf="isInEditMode('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')"
                                               (ngModelChange)="setEditValue('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green">₪</span>
                                        <img *ngIf="!isInEditMode('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price', printingService === 'express' ? getExpressPaperDefaultPrice(paper) : paper.paperType.defaultPrice)">
                                        <mat-icon *ngIf="isInEditMode('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price', printingService === 'express' ? getExpressPaperDefaultPrice(paper) : paper.paperType.defaultPrice) ? priceMenu : null"
                                                  (click)="hasValueChanged('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price', printingService === 'express' ? getExpressPaperDefaultPrice(paper) : paper.paperType.defaultPrice) ? $event.stopPropagation() : cancelEdit('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')">
                                                  {{ hasValueChanged('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price', printingService === 'express' ? getExpressPaperDefaultPrice(paper) : paper.paperType.defaultPrice) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #priceMenu="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                            <button *ngIf="hasMultipleItemsInCategory('paper')" mat-menu-item (click)="applyToAllTypes('paper', (printingService === 'express' ? paper.serial_name : paper.paperType.paperType) + '_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit_note</mat-icon>
                                                    <span>{{ "su-management.apply-to-all-types" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="text-muted small" *ngIf="printingService !== 'express'">
                                    <div class="mb-1">{{ "su-management.roll-length" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('paper', paper.paperType.paperType + '_length')" class="fw-bold text-green">
                                            {{ (updatedValues['paper'] && updatedValues['paper'][paper.paperType.paperType + '_length'] !== undefined) ? updatedValues['paper'][paper.paperType.paperType + '_length'] : paper.paperType.defaultLength }}
                                        </span>
                                        <input *ngIf="isInEditMode('paper', paper.paperType.paperType + '_length')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('paper', paper.paperType.paperType + '_length')"
                                               (ngModelChange)="setEditValue('paper', paper.paperType.paperType + '_length', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green small">ס"מ</span>
                                        <img *ngIf="!isInEditMode('paper', paper.paperType.paperType + '_length')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('paper', paper.paperType.paperType + '_length', paper.paperType.defaultLength)">
                                        <mat-icon *ngIf="isInEditMode('paper', paper.paperType.paperType + '_length')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('paper', paper.paperType.paperType + '_length', paper.paperType.defaultLength) ? lengthMenu : null"
                                                  (click)="hasValueChanged('paper', paper.paperType.paperType + '_length', paper.paperType.defaultLength) ? $event.stopPropagation() : cancelEdit('paper', paper.paperType.paperType + '_length')">
                                                  {{ hasValueChanged('paper', paper.paperType.paperType + '_length', paper.paperType.defaultLength) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #lengthMenu="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('paper', paper.paperType.paperType + '_length')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                            <button *ngIf="hasMultipleItemsInCategory('paper')" mat-menu-item (click)="applyToAllTypes('paper', paper.paperType.paperType + '_length')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit_note</mat-icon>
                                                    <span>{{ "su-management.apply-to-all-types" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="text-muted small" *ngIf="printingService === 'express'">
                                    <div class="mb-1">{{ "printing-table.sheets-per-package" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('paper', paper.serial_name + '_sheets')" class="fw-bold text-green">
                                            {{ (updatedValues['paper'] && updatedValues['paper'][paper.serial_name + '_sheets'] !== undefined) ? updatedValues['paper'][paper.serial_name + '_sheets'] : getExpressPaperSheetsPerPackage(paper) }}
                                        </span>
                                        <input *ngIf="isInEditMode('paper', paper.serial_name + '_sheets')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('paper', paper.serial_name + '_sheets')"
                                               (ngModelChange)="setEditValue('paper', paper.serial_name + '_sheets', $event)" 
                                               matInput type="number" min="0">
                                        <img *ngIf="!isInEditMode('paper', paper.serial_name + '_sheets')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('paper', paper.serial_name + '_sheets', getExpressPaperSheetsPerPackage(paper))">
                                        <mat-icon *ngIf="isInEditMode('paper', paper.serial_name + '_sheets')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('paper', paper.serial_name + '_sheets', getExpressPaperSheetsPerPackage(paper)) ? sheetsMenu : null"
                                                  (click)="hasValueChanged('paper', paper.serial_name + '_sheets', getExpressPaperSheetsPerPackage(paper)) ? $event.stopPropagation() : cancelEdit('paper', paper.serial_name + '_sheets')">
                                                  {{ hasValueChanged('paper', paper.serial_name + '_sheets', getExpressPaperSheetsPerPackage(paper)) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #sheetsMenu="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('paper', paper.serial_name + '_sheets')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                            <button *ngIf="hasMultipleItemsInCategory('paper')" mat-menu-item (click)="applyToAllTypes('paper', paper.serial_name + '_sheets')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit_note</mat-icon>
                                                    <span>{{ "su-management.apply-to-all-types" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center pt-2 gap-sm-1 col-6">
                                <span class="zx-text-tiny opacity-75">
                                    {{ "su-management.inventory-management.short" | translate }}
                                </span>
                                <span class="zx-text-small zx-text-sm-medium fw-bold"
                                      [class.text-red]="getPaperStock(printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType) <= 0"
                                      [class.text-green]="getPaperStock(printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType) > 0">
                                    <span>{{ getPaperStock(printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType) }}</span>
                                    <span class="zx-text-tiny-tiny">{{ "su-management.units.short" | translate }}</span>
                                </span>
                                <div class="d-flex align-items-center gap-1">
                                    <button mat-icon-button (click)="changeOrderQuantity('remove', 'paper', printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType)"
                                        [disabled]="getOrderQuantity('paper', printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType) <= 0">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                    <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                        [ngModel]="getOrderQuantity('paper', printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType)"
                                        (ngModelChange)="setOrderQuantity('paper', printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType, $event)" 
                                        matInput type="number" min="0">
                                    <button mat-icon-button (click)="changeOrderQuantity('add', 'paper', printingService === 'express' ? (paper.serial_name || paper.paperName) : paper.paperType.paperType)">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="getPaperTypes().length === 0" class="text-muted">
                    <p>{{ "error-title-MISSING_DATA" | translate }}</p>
                </div>
            </div>
            
            <!-- Ink Section (normal) or Ribon Section (pics printer) -->
            <div class="mb-4" *ngIf="!isPicsPrinter || printingService !== 'express'">
                <h5 class="text-green fw-bold mb-4 px-3">
                    {{ "su-management.ink" | translate }}
                </h5>
                <div *ngIf="getInkStatus().length > 0" class="row g-2">
                    <div *ngFor="let ink of getInkStatus()" class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                        <div class="row w-100">
                            <div class="d-flex justify-content-between align-items-center p-2 h-100">
                            <div class="d-flex flex-column px-3">
                                <span class="fw-bold mb-2" [class.text-white]="isDarkMode">
                                    {{ getInkIdentifier(ink) }} <span class="text-muted small fw-normal">({{ 'ink-type.name.' + getInkIdentifier(ink) | translate }})</span>
                                </span>
                                <span class="text-muted small mb-2">
                                    {{ "su-management.ink" | translate }}: {{ ink.level }}%
                                </span>
                                <div class="text-muted small mb-2" *ngIf="allInks && allInks.length > 0">
                                    <div class="mb-1">{{ "su-management.price" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('ink', getInkIdentifier(ink) + '_price')" class="fw-bold text-green">{{ getInkDefaultPrice(getInkIdentifier(ink)) }}</span>
                                        <input *ngIf="isInEditMode('ink', getInkIdentifier(ink) + '_price')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('ink', getInkIdentifier(ink) + '_price')"
                                               (ngModelChange)="setEditValue('ink', getInkIdentifier(ink) + '_price', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green">₪</span>
                                        <img *ngIf="!isInEditMode('ink', getInkIdentifier(ink) + '_price')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('ink', getInkIdentifier(ink) + '_price', getInkDefaultPrice(getInkIdentifier(ink)))">
                                        <mat-icon *ngIf="isInEditMode('ink', getInkIdentifier(ink) + '_price')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('ink', getInkIdentifier(ink) + '_price', getInkDefaultPrice(getInkIdentifier(ink))) ? inkPriceMenu : null"
                                                  (click)="hasValueChanged('ink', getInkIdentifier(ink) + '_price', getInkDefaultPrice(getInkIdentifier(ink))) ? $event.stopPropagation() : cancelEdit('ink', getInkIdentifier(ink) + '_price')">
                                                  {{ hasValueChanged('ink', getInkIdentifier(ink) + '_price', getInkDefaultPrice(getInkIdentifier(ink))) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #inkPriceMenu="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('ink', getInkIdentifier(ink) + '_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                            <button *ngIf="hasMultipleItemsInCategory('ink')" mat-menu-item (click)="applyToAllTypes('ink', getInkIdentifier(ink) + '_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit_note</mat-icon>
                                                    <span>{{ "su-management.apply-to-all-types" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="text-muted small" *ngIf="allInks && allInks.length > 0">
                                    <div class="mb-1">{{ "su-management.amount-in-container" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('ink', getInkIdentifier(ink) + '_amount')" class="fw-bold text-green">{{ getInkDefaultAmount(getInkIdentifier(ink)) }}</span>
                                        <input *ngIf="isInEditMode('ink', getInkIdentifier(ink) + '_amount')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('ink', getInkIdentifier(ink) + '_amount')"
                                               (ngModelChange)="setEditValue('ink', getInkIdentifier(ink) + '_amount', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green small">{{ "su-management.ink-ml" | translate }}</span>
                                        <img *ngIf="!isInEditMode('ink', getInkIdentifier(ink) + '_amount')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('ink', getInkIdentifier(ink) + '_amount', getInkDefaultAmount(getInkIdentifier(ink)))">
                                        <mat-icon *ngIf="isInEditMode('ink', getInkIdentifier(ink) + '_amount')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('ink', getInkIdentifier(ink) + '_amount', getInkDefaultAmount(getInkIdentifier(ink))) ? inkAmountMenu : null"
                                                  (click)="hasValueChanged('ink', getInkIdentifier(ink) + '_amount', getInkDefaultAmount(getInkIdentifier(ink))) ? $event.stopPropagation() : cancelEdit('ink', getInkIdentifier(ink) + '_amount')">
                                                  {{ hasValueChanged('ink', getInkIdentifier(ink) + '_amount', getInkDefaultAmount(getInkIdentifier(ink))) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #inkAmountMenu="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('ink', getInkIdentifier(ink) + '_amount')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                            <button *ngIf="hasMultipleItemsInCategory('ink')" mat-menu-item (click)="applyToAllTypes('ink', getInkIdentifier(ink) + '_amount')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit_note</mat-icon>
                                                    <span>{{ "su-management.apply-to-all-types" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center pt-2 gap-sm-1 col-6">
                                <span class="zx-text-tiny opacity-75">
                                    {{ "su-management.inventory-management.short" | translate }}
                                </span>
                                <span class="zx-text-small zx-text-sm-medium fw-bold"
                                      [class.text-red]="getInkStock(getInkIdentifier(ink)) <= 0"
                                      [class.text-green]="getInkStock(getInkIdentifier(ink)) > 0">
                                    <span>{{ getInkStock(getInkIdentifier(ink)) }}</span>
                                    <span class="zx-text-tiny-tiny">{{ "su-management.units.short" | translate }}</span>
                                </span>
                                <div class="d-flex align-items-center gap-1">
                                    <button mat-icon-button (click)="changeOrderQuantity('remove', 'ink', getInkIdentifier(ink))"
                                        [disabled]="getOrderQuantity('ink', getInkIdentifier(ink)) <= 0">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                    <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                        [ngModel]="getOrderQuantity('ink', getInkIdentifier(ink))"
                                        (ngModelChange)="setOrderQuantity('ink', getInkIdentifier(ink), $event)" 
                                        matInput type="number" min="0">
                                    <button mat-icon-button (click)="changeOrderQuantity('add', 'ink', getInkIdentifier(ink))">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="getInkStatus().length === 0" class="text-muted">
                    <p>{{ "error-title-MISSING_DATA" | translate }}</p>
                </div>
            </div>
            
            <!-- Ribon Section (pics printer only) -->
            <div class="mb-4" *ngIf="isPicsPrinter && printingService === 'express'">
                <h5 class="text-green fw-bold mb-4 px-3">
                    {{ "su-management.ribon" | translate }}
                </h5>
                <div class="row g-2">
                    <!-- Images card -->
                    <div class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                        <div class="row w-100">
                            <div class="d-flex justify-content-between align-items-center p-2 h-100">
                            <div class="d-flex flex-column px-3">
                                <span class="fw-bold mb-2" [class.text-white]="isDarkMode">
                                    {{ "paper-type.name-short.images" | translate }}
                                </span>
                                <div class="text-muted small mb-2" *ngIf="allInks && allInks.length > 0">
                                    <div class="mb-1">{{ "su-management.price" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('ink', 'ribon_price')" class="fw-bold text-green">{{ getRibonDefaultPrice() }}</span>
                                        <input *ngIf="isInEditMode('ink', 'ribon_price')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('ink', 'ribon_price')"
                                               (ngModelChange)="setEditValue('ink', 'ribon_price', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green">₪</span>
                                        <img *ngIf="!isInEditMode('ink', 'ribon_price')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('ink', 'ribon_price', getRibonDefaultPrice())">
                                        <mat-icon *ngIf="isInEditMode('ink', 'ribon_price')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('ink', 'ribon_price', getRibonDefaultPrice()) ? ribonPriceMenuImages : null"
                                                  (click)="hasValueChanged('ink', 'ribon_price', getRibonDefaultPrice()) ? $event.stopPropagation() : cancelEdit('ink', 'ribon_price')">
                                                  {{ hasValueChanged('ink', 'ribon_price', getRibonDefaultPrice()) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #ribonPriceMenuImages="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('ink', 'ribon_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="text-muted small" *ngIf="allInks && allInks.length > 0">
                                    <div class="mb-1">{{ "su-management.amount-images-in-ribon" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('ink', 'ribon_amount')" class="fw-bold text-green">{{ getRibonDefaultAmount() }}</span>
                                        <input *ngIf="isInEditMode('ink', 'ribon_amount')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('ink', 'ribon_amount')"
                                               (ngModelChange)="setEditValue('ink', 'ribon_amount', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green small">{{ "su-management.units.short" | translate }}</span>
                                        <img *ngIf="!isInEditMode('ink', 'ribon_amount')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('ink', 'ribon_amount', getRibonDefaultAmount())">
                                        <mat-icon *ngIf="isInEditMode('ink', 'ribon_amount')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('ink', 'ribon_amount', getRibonDefaultAmount()) ? ribonAmountMenuImages : null"
                                                  (click)="hasValueChanged('ink', 'ribon_amount', getRibonDefaultAmount()) ? $event.stopPropagation() : cancelEdit('ink', 'ribon_amount')">
                                                  {{ hasValueChanged('ink', 'ribon_amount', getRibonDefaultAmount()) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #ribonAmountMenuImages="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('ink', 'ribon_amount')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center pt-2 gap-sm-1 col-6">
                                <span class="zx-text-tiny opacity-75">
                                    {{ "su-management.inventory-management.short" | translate }}
                                </span>
                                <span class="zx-text-small zx-text-sm-medium fw-bold"
                                      [class.text-red]="getRibonStock('ribons') <= 0"
                                      [class.text-green]="getRibonStock('ribons') > 0">
                                    <span>{{ getRibonStock('ribons') }}</span>
                                    <span class="zx-text-tiny-tiny">{{ "su-management.units.short" | translate }}</span>
                                </span>
                                <div class="d-flex align-items-center gap-1">
                                    <button mat-icon-button (click)="changeOrderQuantity('remove', 'paper', 'ribons')"
                                        [disabled]="getOrderQuantity('paper', 'ribons') <= 0">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                    <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                        [ngModel]="getOrderQuantity('paper', 'ribons')"
                                        (ngModelChange)="setOrderQuantity('paper', 'ribons', $event)" 
                                        matInput type="number" min="0">
                                    <button mat-icon-button (click)="changeOrderQuantity('add', 'paper', 'ribons')">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                                <!-- Images count display - under "amount-images-in-ribon" -->
                                <div class="d-flex flex-column align-items-center mt-2 pt-2" style="border-top: 1px solid rgba(0,0,0,0.1);">
                                    <span class="zx-text-tiny opacity-75 mb-1">
                                        {{ "paper-type.name-short.images" | translate }}
                                    </span>
                                    <span class="zx-text-small zx-text-sm-medium fw-bold"
                                          [class.text-red]="getRibonStock('images') <= 0"
                                          [class.text-green]="getRibonStock('images') > 0">
                                        <span>{{ getRibonStock('images') }}</span>
                                        <span class="zx-text-tiny-tiny">{{ "su-management.units.short" | translate }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Waste Cartridge Section (hidden for pics printer) -->
            <div class="mb-4" *ngIf="!isPicsPrinter || printingService !== 'express'">
                <h5 class="text-green fw-bold mb-4 px-3">
                    {{ "ink-type.name.Waste" | translate }}
                </h5>
                <div *ngIf="getWasteInk()" class="row g-2">
                    <div class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                        <div class="row w-100">
                            <div class="d-flex justify-content-between align-items-center p-2 h-100">
                            <div class="d-flex flex-column px-3">
                                <span class="fw-bold mb-2" [class.text-white]="isDarkMode">
                                    {{ "ink-type.name.Waste" | translate }}
                                </span>
                                <span class="text-muted small mb-2">
                                    {{ "su-management.amount-in-container" | translate }}: {{ getWasteInk().level }}%
                                </span>
                                <div class="text-muted small mb-2" *ngIf="allInks && allInks.length > 0">
                                    <div class="mb-1">{{ "su-management.price" | translate }}:</div>
                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                        <span *ngIf="!isInEditMode('ink', 'waste_price')" class="fw-bold text-green">{{ getInkDefaultPrice('waste') }}</span>
                                        <input *ngIf="isInEditMode('ink', 'waste_price')" 
                                               class="zx-inventory-input" 
                                               [class.zx-text-white-bg-transparent]="isDarkMode"
                                               [ngModel]="getEditValue('ink', 'waste_price')"
                                               (ngModelChange)="setEditValue('ink', 'waste_price', $event)" 
                                               matInput type="number" min="0">
                                        <span class="fw-bold text-green">₪</span>
                                        <img *ngIf="!isInEditMode('ink', 'waste_price')" 
                                             src="assets/images/chainge-icon-green.svg" 
                                             class="svg c-pointer" 
                                             style="width: 16px; height: 16px;"
                                             (click)="startEdit('ink', 'waste_price', getInkDefaultPrice('waste'))">
                                        <mat-icon *ngIf="isInEditMode('ink', 'waste_price')" 
                                                  class="c-pointer text-green d-flex align-items-center" 
                                                  style="width: 16px; height: 16px; font-size: 16px;"
                                                  [matMenuTriggerFor]="hasValueChanged('ink', 'waste_price', getInkDefaultPrice('waste')) ? wastePriceMenu : null"
                                                  (click)="hasValueChanged('ink', 'waste_price', getInkDefaultPrice('waste')) ? $event.stopPropagation() : cancelEdit('ink', 'waste_price')">
                                                  {{ hasValueChanged('ink', 'waste_price', getInkDefaultPrice('waste')) ? 'check' : 'close' }}
                                        </mat-icon>
                                        
                                        <mat-menu #wastePriceMenu="matMenu">
                                            <button mat-menu-item (click)="applyToCurrentType('ink', 'waste_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit</mat-icon>
                                                    <span>{{ "su-management.apply-to-current-type" | translate }}</span>
                                                </div>
                                            </button>
                                            <button *ngIf="false" mat-menu-item (click)="applyToAllTypes('ink', 'waste_price')">
                                                <div class="d-flex gap-1">
                                                    <mat-icon class="zx-text-medium zx-text-sm-big pt-1">edit_note</mat-icon>
                                                    <span>{{ "su-management.apply-to-all-types" | translate }}</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-items-center pt-2 gap-sm-1 col-6">
                                <span class="zx-text-tiny opacity-75">
                                    {{ "su-management.inventory-management.short" | translate }}
                                </span>
                                <span class="zx-text-small zx-text-sm-medium fw-bold"
                                      [class.text-red]="getWasteStock() <= 0"
                                      [class.text-green]="getWasteStock() > 0">
                                    <span>{{ getWasteStock() }}</span>
                                    <span class="zx-text-tiny-tiny">{{ "su-management.units.short" | translate }}</span>
                                </span>
                                <div class="d-flex align-items-center gap-1">
                                    <button mat-icon-button (click)="changeOrderQuantity('remove', 'waste', 'waste')"
                                        [disabled]="getOrderQuantity('waste', 'waste') <= 0">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                    <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                        [ngModel]="getOrderQuantity('waste', 'waste')"
                                        (ngModelChange)="setOrderQuantity('waste', 'waste', $event)" 
                                        matInput type="number" min="0">
                                    <button mat-icon-button (click)="changeOrderQuantity('add', 'waste', 'waste')">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!getWasteInk()" class="text-muted">
                    <p>{{ "error-title-MISSING_DATA" | translate }}</p>
                </div>
            </div>
            
            <!-- Order Arrived at Branch Checkbox -->
            <div class="mb-2">
                <div class="d-flex align-items-center px-3">
                    <mat-checkbox 
                        [(ngModel)]="orderArrivedAtBranch"
                        class="me-3">
                    </mat-checkbox>
                    <span class="ms-3" [class.text-white]="isDarkMode">
                        {{ "su-management.order-arrived-at-branch" | translate }}
                    </span>
                    <img 
                        src="/assets/images/i-explain-icon.svg"
                        class="i-explain-icon svg c-pointer me-2"
                        matTooltip="{{ 'su-management.order-arrived-at-branch-tooltip' | translate }}"
                        matTooltipPosition="above">
                </div>
            </div>
        </div>
        <!-- // Dialog content container -->
</div>
<!-- End of main content -->

        </div>
        <!-- End of content below title -->

    <!-- Order Confirmation Button -->
    <div *ngIf="!showOrderSummary" class="d-flex flex-column px-4 pb-4 col-12 justify-content-center w-100">
        <!-- Supplier name input - always last before button -->
        <div class="w-100 px-3 mb-4">
            <label for="supplierName" class="form-label text-green mb-2" [class.text-white]="isDarkMode">
                {{ 'su-management.supplier' | translate }}
            </label>
            <input 
                type="text" 
                id="supplierName"
                class="form-control" 
                [(ngModel)]="supplierName"
                placeholder="{{ 'su-management.supplier' | translate }}"
                [class.text-white]="isDarkMode"
                [class.bg-dark]="isDarkMode">
        </div>
        
        <!-- Supplier validation warning -->
        <div *ngIf="!isSupplierValid()" class="alert alert-danger mb-3 text-center" role="alert">
            {{ 'su-management.supplier-required' | translate }}
        </div>
        
        <button class="text-white rounded-pill w-100 zx-small-btn" type="button" mat-raised-button color="primary"
                [disabled]="isOrderButtonDisabled()"
                (click)="confirmOrder()">
            {{ 'choose-system.continue' | translate }}
        </button>
    </div>

    <!-- Order Summary -->
    <div *ngIf="showOrderSummary && !isSubmittingOrder && !showSuccessMessage" class="p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="text-green mb-0" [class.text-white]="isDarkMode">
                {{ 'su-management.order-summary' | translate }}
            </h5>
            <button class="btn btn-outline-secondary btn-sm" (click)="backToOrderForm()">
                {{ 'su-management.back-to-order' | translate }}
            </button>
        </div>
        
        <div class="table-responsive">
            <table class="table table-striped w-100">
                <thead>
                    <tr>
                        <th class="col-3">{{ 'su-management.item' | translate }}</th>
                        <th class="col-2">{{ 'su-management.quantity' | translate }}</th>
                        <th class="col-3">{{ 'su-management.amount' | translate }}</th>
                        <th class="col-2">{{ 'su-management.unit-price' | translate }}</th>
                        <th class="col-2">{{ 'su-management.total-price' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of getOrderSummaryItems()">
                        <td class="col-3">{{ item.name }}</td>
                        <td class="col-2">{{ item.quantity }}</td>
                        <td class="col-3">{{ item.amount }}</td>
                        <td class="col-2">{{ item.unitPrice }} ₪</td>
                        <td class="col-2">{{ item.totalPrice }} ₪</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="table-success">
                        <th class="col-8" colspan="4">{{ 'su-management.total' | translate }}</th>
                        <th class="col-2">{{ getTotalOrderPrice() }} ₪</th>
                    </tr>
                </tfoot>
            </table>
        </div>
        
        <!-- Order Arrived at Branch Checkbox - also shown in summary -->
        <div class="mt-5">
            <div class="d-flex align-items-center px-3">
                <mat-checkbox 
                    [(ngModel)]="orderArrivedAtBranch"
                    class="me-3">
                </mat-checkbox>
                <span class="ms-3" [class.text-white]="isDarkMode">
                    {{ "su-management.order-arrived-at-branch" | translate }}
                </span>
                <img 
                    src="/assets/images/i-explain-icon.svg"
                    class="i-explain-icon svg c-pointer me-2"
                    matTooltip="{{ 'su-management.order-arrived-at-branch-tooltip' | translate }}"
                    matTooltipPosition="above">
            </div>
        </div>
        
        <!-- Supplier name input - also shown in summary -->
        <div class="w-100 px-3 mb-5">
            <label for="supplierNameSummary" class="form-label text-green mb-2" [class.text-white]="isDarkMode">
                {{ 'su-management.supplier' | translate }}
            </label>
            <input 
                type="text" 
                id="supplierNameSummary"
                class="form-control" 
                [(ngModel)]="supplierName"
                placeholder="{{ 'su-management.supplier' | translate }}"
                [class.text-white]="isDarkMode"
                [class.bg-dark]="isDarkMode">
        </div>
        
        <!-- Confirm Order Button -->
        <div class="d-flex flex-column px-4 pb-4 col-12 justify-content-center w-100">
            <!-- Supplier validation warning -->
            <div *ngIf="!isSupplierValid()" class="alert alert-warning mb-3 text-center" role="alert">
                {{ 'su-management.supplier-required' | translate }}
            </div>
            
            <button class="text-white rounded-pill w-100 zx-small-btn" type="button" mat-raised-button color="primary"
                    [disabled]="!isSupplierValid() || isSubmittingOrder"
                    (click)="confirmFinalOrder()">
                <span *ngIf="!isSubmittingOrder">{{ 'su-management.confirm-order' | translate }}</span>
                <span *ngIf="isSubmittingOrder" class="d-flex align-items-center justify-content-center">
                    <mat-spinner diameter="20" color="accent" class="me-2"></mat-spinner>
                    {{ 'su-management.submitting-order' | translate }}
                </span>
            </button>
        </div>
        </div>
        <!-- End of content that hides when submitting -->
        </div>

</div>
